<script>
  import AppNavigation from './AppNavigation.svelte'
  import HamburgerMenu from './HamburgerMenu.svelte'
</script>

<div class="fixed min-w-[300px] top-0 inset-x-0 bg-white z-50">
  <div class="container">
    <header class="flex justify-between items-center py-5 pl-8 pr-4 ">
      <img class="w-48" src="./assets/eurocontact.svg" alt="">
      <AppNavigation />
      <HamburgerMenu />
    </header>
  </div>
</div>